/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Skeleton/theme';

export const SkeletonTheme = theme;
